module.exports = __webpack_public_path__ + "static/media/logo_wingswept.962db94e.jpg";